class Utils {
  static setBackgroundColor(color) {
    document.body.style.background = color;
  }

  static roundDecimals(amount, decimals) {
    return Math.round(amount * (10 ** decimals)) / (10 ** decimals);
  }

  static whichAnimationEvent() {
    const el = document.createElement('div');

    const animations = {
      animation: 'animationend',
      OAnimation: 'oAnimationEnd',
      MozAnimation: 'animationend',
      WebkitAnimation: 'webkitAnimationEnd',
    };

    const typeOfAnimations = Object.keys(animations);

    for (let i = 0, l = typeOfAnimations.length; i < l; i += 1) {
      const animation = animations[typeOfAnimations[i]];
      if (el.style[animation] !== undefined) {
        return animations[animation];
      }
    }

    return false;
  }

  static parseNumber(string) {
    if (!string) return 0;

    let strg = String(string);

    let decimal = '.';
    const numberOfDecimals = 8;

    strg = strg.replace(/[^0-9$.,]/g, '');

    if (strg.indexOf(',') > strg.indexOf('.')) decimal = ',';
    if ((strg.match(new RegExp(`\\${decimal}`, 'g')) || []).length > 1) decimal = '';
    // if (decimal !== '' && (strg.length - strg.indexOf(decimal) - 1 === 3)
    // && strg.indexOf(`0${decimal}`) !== 0) decimal = '';

    strg = strg.replace(new RegExp(`[^0-9$${decimal}]`, 'g'), '');
    strg = strg.replace(',', '.');

    const number = parseFloat(strg);
    return Math.round(number * (10 ** numberOfDecimals)) / (10 ** numberOfDecimals);
  }

  static numberFormat(number, decimals, decimalPoint = '.', thousandsSeparator = ',') {
    const toFixedFix = (n, prec) => {
      const k = (10 ** prec);
      return `${Math.round(n * k) / k}`;
    };
    const strippedNumber = (`${number}`).replace(/[^0-9+\-Ee.]/g, '');
    const n = !Number.isFinite(+strippedNumber) ? 0 : +strippedNumber;
    let s;
    let prec = 0;
    if (decimals !== '?') {
      prec = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals);
      s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
    } else {
      s = String(n).split('.');
    }
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, thousandsSeparator);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array((prec - s[1].length) + 1).join('0');
    }

    return s.join(decimalPoint);
  }

  static coinNumberFormat(value, defaultDecimalCount = 2, method, decimalPoint = '.', thousandsSeparator = ',') {
    const price = Number(value);
    let decimalCount = defaultDecimalCount;

    if (price === 0) return 0;
    if (price <= 0.000001) {
      decimalCount = 9;
    } else if (price.toFixed(3) < 1) {
      const decimalZeros = -Math.floor(Math.log(price) / (Math.log(10) + 1));

      if (decimalZeros === 0) {
        decimalCount = 3;
      } else {
        decimalCount = decimalZeros + 3;
      }
    }

    let roundedPrice = price;
    switch (method) {
      case 'ceil':
        roundedPrice = Math.ceil(price * (10 ** decimalCount)) / (10 ** decimalCount);
        break;
      case 'floor':
        roundedPrice = Math.floor(price * (10 ** decimalCount)) / (10 ** decimalCount);
        break;
      default:
    }

    return this.numberFormat(roundedPrice, decimalCount, decimalPoint, thousandsSeparator);
  }

  static getBaseSymbol(currency = 'USD') {
    switch (currency) {
      case 'AUD':
        return '$';
      case 'BGN':
        return 'лв';
      case 'BRL':
        return 'R$';
      case 'CAD':
        return 'C$';
      case 'CHF':
        return 'CHF';
      case 'CNY':
        return '¥';
      case 'CZK':
        return 'Kč';
      case 'DKK':
        return 'kr';
      case 'EUR':
        return '€';
      case 'GBP':
        return '£';
      case 'HKD':
        return 'HK$';
      case 'HRK':
        return 'kn';
      case 'HUF':
        return 'Ft';
      case 'IDR':
        return 'Rp';
      case 'ILS':
        return '₪';
      case 'INR':
        return '₹';
      case 'JPY':
        return '¥';
      case 'KRW':
        return '₩';
      case 'MXN':
        return '$';
      case 'MYR':
        return 'RM';
      case 'NOK':
        return 'kr';
      case 'NZD':
        return '$';
      case 'PHP':
        return '₱';
      case 'PLN':
        return 'zł';
      case 'RON':
        return 'lei';
      case 'RUB':
        return '₽';
      case 'SEK':
        return 'kr';
      case 'SGD':
        return 'S$';
      case 'THB':
        return '฿';
      case 'TRY':
        return '₺';
      case 'USD':
        return '$';
      case 'ZAR':
        return 'R';
      case 'BTC':
        return 'Ƀ';
      case 'ETH':
        return 'Ξ';
      default:
        return '$';
    }
  }

  static timestampToDate(timestamp) {
    return new Date(timestamp).toString().slice(4, 21);
  }
}

export default Utils;



// WEBPACK FOOTER //
// ./src/libs/Utils.js